import Router from 'vue-routes-generator'
import GaleriasComponent from './galerias.vue'
import VisorGaleria from './componentes/visor-galerias/visor-galeria'
import ListadoGalerias from './componentes/listado-galerias/listado-galerias.vue'
import Buscador from './componentes/buscador/vista-buscador'
import MainStore from '../../core/vue/store/stores'
import Store from './store'

export default {
	install: Vue => {
		Router.route('/main').child('galerias', {
			name: 'Galerías',
			component: GaleriasComponent
		})
		Router.route('/main').child('galerias').child('', {
			name: 'Principal',
			component: ListadoGalerias
		})
		Router.route('/main').child('galerias').child('buscador', {
			name: 'Buscador',
			component: Buscador
		})

		Router.route('/main').child('galerias').child(':id', {
			name: 'Visor de galería',
			component: VisorGaleria
		})

		MainStore.registerModule(['galerias'], Store)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/galerias/vue/index.js